import { HELPER, CONSTANTS, LANG_FORMAT, PRODUCT_HELPER } from '../../../utils'
import { store } from '../../../store'
import { alertActions } from '../../../store/actions'
import APP_HELPER from './appHelper'

function formatCharges(currency, charges, roundOff = true) {
	let charge = !HELPER.isEmpty(charges) ? parseFloat(charges, 2) : '0.00'
	let roundOffCharge = roundOff ? charge : charge
	if (APP_HELPER.GET_LANG_DIRECTION() === CONSTANTS.LANG_DIRECTION.LTR) {
		return currency + ' ' + HELPER.parseToFloat(roundOffCharge, 2)
	} else {
		return HELPER.parseToFloat(roundOffCharge, 2) + ' ' + currency
	}
}

function cartAddRules(product_item, maximum_purchase_limit) {
	let product = {
		applicable: true,
	}
	if (
		HELPER.isEmpty(product_item) ||
		product_item.discounted_price > parseInt(maximum_purchase_limit)
	) {
		// if (HELPER.isEmpty(product_item) || product_item.price > parseInt(maximum_purchase_limit)) {
		product.applicable = false
	}
	return product
}

function MaxQuantityReached(selected_product) {
	const state = store.getState()
	const { translate } = state.meta.translation
	const max_quantity = PRODUCT_HELPER.PRODUCT_MAX_QUANTITY(selected_product)

	let MESSAGE_OPTIONS = {
		max_quantity: `<b>${max_quantity}</b>`,
	}
	let toastMsg = LANG_FORMAT.FORMAT_MAX_QUANTITY_REACH_MSG(
		translate('CART.MAX_LIMIT_QUANTITY', MESSAGE_OPTIONS),
		MESSAGE_OPTIONS.max_quantity
	)
	store.dispatch(alertActions.warning(toastMsg, CONSTANTS.ERROR_TYPE.TOAST, true))
	return true
}

function outOfStock() {
	const state = store.getState()
	const { translate } = state.meta.translation
	let toastMsg = translate('CART.OUT_OF_STOCK')
	store.dispatch(alertActions.warning(toastMsg, CONSTANTS.ERROR_TYPE.TOAST, true))
	return true
}

function ShowAddToCardMsg(product) {
	const state = store.getState()
	const { translate } = state.meta.translation

	let MESSAGE_OPTIONS = {
		item_name: `<b>${product?.name}</b>`,
	}
	let toastMsg = LANG_FORMAT.FORMAT_CART_ITEM_ADD_MSG(
		translate('CART.ITEM_ADDED', MESSAGE_OPTIONS),
		MESSAGE_OPTIONS.item_name
	)
	store.dispatch(alertActions.success(toastMsg, CONSTANTS.ERROR_TYPE.TOAST, true))
	return true
}

function AddCartRule(setLimit = false, delivery_type, sub_total_amount) {
	const state = store.getState()
	// addToast, translate
	let maximum_purchase_limit = setLimit
	if (!setLimit) {
		maximum_purchase_limit = state.inventory.inventory_settings.maximum_purchase_limit
	}
	const { translate } = state.meta.translation
	let MESSAGE_OPTIONS
	if (
		delivery_type === CONSTANTS.DELIVERY_TYPE.PURCHASE &&
		parseInt(maximum_purchase_limit) >= parseInt(sub_total_amount)
	) {
		return true
	} else if (delivery_type === CONSTANTS.DELIVERY_TYPE.PICKUP) {
		return true
	} else {
		MESSAGE_OPTIONS = {
			max_amount: maximum_purchase_limit,
		}
		let toastMsg = LANG_FORMAT.FORMAT_PURCHASE_TYPE_MAX_LIMIT_MSG(
			translate('CART.PURCHASE_TYPE_MAX_LIMIT', MESSAGE_OPTIONS),
			MESSAGE_OPTIONS.max_amount
		)
		store.dispatch(alertActions.error(toastMsg, CONSTANTS.ERROR_TYPE.TOAST, true))
		return false
	}
}

function UpdateCartRule() {
	const state = store.getState()
	const { inventory_settings } = state.inventory
	const { item_added, cart_items } = state.cart
	const { sub_total_amount } = cart_items
	const { translate } = state.meta.translation
	const { maximum_purchase_limit } = inventory_settings
	let MESSAGE_OPTIONS
	if (
		item_added.item.product_delivery_type === CONSTANTS.DELIVERY_TYPE.PURCHASE &&
		parseInt(maximum_purchase_limit) >= parseInt(sub_total_amount)
	) {
		return true
	} else if (item_added.item.product_delivery_type === CONSTANTS.DELIVERY_TYPE.PICKUP) {
		return true
	} else {
		MESSAGE_OPTIONS = {
			item_name: `<b>${item_added.item?.name}</b>`,
		}
		let toastMsg = LANG_FORMAT.FORMAT_CART_ITEM_ADD_MSG(
			translate('CART.ITEM_ADDED', MESSAGE_OPTIONS),
			MESSAGE_OPTIONS.item_name
		)
		store.dispatch(alertActions.success(toastMsg, CONSTANTS.ERROR_TYPE.TOAST, true))
		return false
	}
}

function DeletedCartItemSuccessMsg(product) {
	const state = store.getState()
	const { translate } = state.meta.translation
	let MESSAGE_OPTIONS = {
		item_name: `<b>${product?.name}</b>`,
	}
	let toastMsg = LANG_FORMAT.FORMAT_CART_ITEM_ADD_MSG(
		translate('CART.ITEM_REMOVED', MESSAGE_OPTIONS),
		MESSAGE_OPTIONS.item_name
	)
	store.dispatch(alertActions.warning(toastMsg, CONSTANTS.ERROR_TYPE.TOAST, true))
}
const MANAGE_CART_HELPER = {
	formatCharges,
	cartAddRules,
	ShowAddToCardMsg,
	DeletedCartItemSuccessMsg,
	AddCartRule,
	UpdateCartRule,
	MaxQuantityReached,
	outOfStock,
}
export default MANAGE_CART_HELPER
